export default class LangSwitcherAction {
    constructor() {
        const current_lang = $('#current-lang')
        const current_lang_menu = $('#current-lang-menu')

        //On init
        $(window).on('load', () => {
            window.setTimeout(() => {
                let current_language = $('html').attr('lang').replace(/-.*/gi, '')
                if (current_language === 'auto') {
                    current_language = 'fr'
                }

                //Replace current lang
                $(current_lang).find('.tools__item__current-lang__code').text(current_language)
                $(current_lang_menu)
                    .find('.menu__tools__item__current-lang__code')
                    .text(current_language)
            }, 500)
        })

        $('#current-lang-menu a').on('click', (event) => {
            event.preventDefault()
            const hashLang = window.hash.replace(/#.*/, '')

            if (hashLang !== '') {
                location.hash = ''
            }
        })

        $('#current-lang a').on('click', (event) => {
            event.preventDefault()
            const hashLang = window.hash.replace(/#.*/, '')

            if (hashLang !== '') {
                location.hash = ''
            }
        })

        //On dropdown
        document.getElementById('current-lang').addEventListener('show.hc.dropdown', () => {
            window.setTimeout(() => {
                const list_langs = $('[data-theme="dropdown"] .glink')

                //Change Navbar Language on select
                $(list_langs).on('click', function () {
                    //Replace current lang
                    $(current_lang).find('.tools__item__current-lang__code').text($(this).text())
                    $(document).find('.menu__tools__item__current-lang__code').text($(this).text())
                    $(current_lang_menu)
                        .find('.menu__tools__item__current-lang__code')
                        .text($(this).text())
                    $(document).find('.tools__item__current-lang__code').text($(this).text())
                })
            }, 500)
        })

        //On dropdown
        document.getElementById('current-lang-menu').addEventListener('show.hc.dropdown', () => {
            window.setTimeout(() => {
                const list_langs = $('[data-theme="dropdown"] .glink')

                //Change Navbar Language on select
                $(list_langs).on('click', function () {
                    //Replace current lang
                    $(current_lang).find('.tools__item__current-lang__code').text($(this).text())
                    $(document).find('.menu__tools__item__current-lang__code').text($(this).text())
                    $(current_lang_menu)
                        .find('.menu__tools__item__current-lang__code')
                        .text($(this).text())
                    $(document).find('.tools__item__current-lang__code').text($(this).text())
                })
            }, 500)
        })
    }
}
